export function formatNumber(num: number | string | null) {
  const n = Number(num || 0);
  return n.toLocaleString("id-ID");
}

export function formatPercentage(pct: unknown) {
  if (pct == null) return "0%";
  const strPct = String(pct).trim();
  if (strPct === "") return "0%";
  return strPct.includes("%") ? strPct : `${strPct}%`;
}
